import React, { useEffect } from 'react';
import BookingForm from './BookingForm';

interface BookingProps {
  language: string;
}

const Booking: React.FC<BookingProps> = ({ language }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1a1a] pt-20 pb-12 relative overflow-hidden">
      {/* Subtle star background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[10%] left-[15%] w-1 h-1 bg-[#f0f0f0] rounded-full opacity-30 animate-pulse" style={{ animationDelay: '0s', animationDuration: '3s' }}></div>
        <div className="absolute top-[25%] right-[20%] w-1.5 h-1.5 bg-[#f0f0f0] rounded-full opacity-40 animate-pulse" style={{ animationDelay: '1s', animationDuration: '4s' }}></div>
        <div className="absolute top-[40%] left-[8%] w-1 h-1 bg-[#f0f0f0] rounded-full opacity-35 animate-pulse" style={{ animationDelay: '2s', animationDuration: '3.5s' }}></div>
        <div className="absolute top-[60%] right-[12%] w-1 h-1 bg-[#f0f0f0] rounded-full opacity-30 animate-pulse" style={{ animationDelay: '0.5s', animationDuration: '4.5s' }}></div>
        <div className="absolute top-[75%] left-[25%] w-1.5 h-1.5 bg-[#f0f0f0] rounded-full opacity-40 animate-pulse" style={{ animationDelay: '1.5s', animationDuration: '3s' }}></div>
        <div className="absolute top-[20%] left-[60%] w-1 h-1 bg-[#f0f0f0] rounded-full opacity-35 animate-pulse" style={{ animationDelay: '2.5s', animationDuration: '4s' }}></div>
        <div className="absolute top-[50%] right-[35%] w-1 h-1 bg-[#f0f0f0] rounded-full opacity-30 animate-pulse" style={{ animationDelay: '3s', animationDuration: '3.5s' }}></div>
        <div className="absolute top-[85%] right-[45%] w-1.5 h-1.5 bg-[#f0f0f0] rounded-full opacity-40 animate-pulse" style={{ animationDelay: '0.8s', animationDuration: '4.2s' }}></div>
        <div className="absolute top-[35%] left-[75%] w-1 h-1 bg-[#f0f0f0] rounded-full opacity-35 animate-pulse" style={{ animationDelay: '1.8s', animationDuration: '3.8s' }}></div>
        <div className="absolute top-[65%] left-[45%] w-1 h-1 bg-[#f0f0f0] rounded-full opacity-30 animate-pulse" style={{ animationDelay: '2.2s', animationDuration: '4.5s' }}></div>
      </div>
      
      <div className="container mx-auto px-4">
        <BookingForm language={language} />
      </div>
    </div>
  );
};

export default Booking;